




























import draggable from 'vuedraggable'
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    components:
    {
        draggable
    }
})
export default class ColumnSetting extends Vue
{
    /**
     * 标题
     * @protected
     * @returns Array<any>
     */
    @Prop({type: Array, default: ()=>([])})
    protected columns: Array<any>

    /**
     * 是否展示table全部列
     * @protected
     * @returns boolean
     */
    protected indeterminate: boolean = false;

    /**
     * 是否展示table 列
     * @protected
     * @returns boolean
     */
    protected checkAll: boolean = false;

    /**
     * 列配置项
     * @protected
     * @returns Array<any>
     */
    protected columnsSetting: Array<any> = [];

    /**
     * 列配置项
     * @protected
     * @returns Array<any>
     */
    protected originColumns: Array<any> = [];

    /**
     * dom加载完
     * @protected
     * @returns void
     */
    protected mounted()
    {
        this.columnsSetting = this.columns.map(value => ({ ...value, checked: true }))
        this.originColumns = JSON.parse(JSON.stringify(this.columnsSetting))
    }

    /**
     * 重置列
     * @protected
     * @returns void
     */
    protected reset(): void
    {
        this.columnsSetting = JSON.parse(JSON.stringify(this.originColumns));
        this.indeterminate = false;
        this.checkAll = true;
        this.emitColumnChange();
    }

    /**
     * 更改显示列
     * @protected
     * @returns void
     */
    protected onChange(): void
    {
        const checkedList = this.columnsSetting.filter(value => value.checked)
        this.indeterminate = !!checkedList.length && checkedList.length < this.columnsSetting.length
        this.checkAll = checkedList.length === this.columnsSetting.length
        this.emitColumnChange()
    }

    /**
     * 全选列变更
     * @protected
     * @returns void
     */
    protected onCheckAllChange(e: any): void
    {
        const val = e.target.checked
        Object.assign(this, {
            indeterminate: false,
            checkAll: val,
            columnsSetting: this.columns.map(value => ({ ...value, checked: val }))
        })
        this.emitColumnChange()
    }

    /**
     * 触发列变更
     * @protected
     * @returns void
     */
    protected emitColumnChange(): void
    {
        this.$emit('columnChange', this.columnsSetting)
    }

}
